import { GET_ALL_SIP_USERS } from "../../api/Actions/ServicePhone";

let initialState = {
  GetAllSipUsers: false,
  errorGetAllSipUsers: false,
};

export const SipUsers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_SIP_USERS:
      return {
        ...state,
        GetAllSipUsers: action.payload.data,
        errorGetAllSipUsers: action.payload.errorMessage,
      };
    default:
      return state;
  }
};
